import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-osk-payment-success',
  templateUrl: './osk-payment-success.component.html',
  styleUrl: './osk-payment-success.component.scss'
})
export class OskPaymentSuccessComponent implements OnInit {
  private _router = inject(Router);

  ngOnInit(): void {
    localStorage.removeItem('selectedSubscriptions');
  }

  goToSubscriptionList(): void {
    this._router.navigate(['/osk-subscriptions/list'])
  }
}
